const PRICE_PANEL_CLASSES_PREFIX = "PricePanel";

export const PRICE_PANEL_CLASSES = {
  currentPrice: `${PRICE_PANEL_CLASSES_PREFIX}-currentPrice`,
  previousPrice: `${PRICE_PANEL_CLASSES_PREFIX}-previousPrice`,
  clearancePrice: `${PRICE_PANEL_CLASSES_PREFIX}-clearancePrice`,
};
